export const WARM_UP_ENABLED = 'warm_up_enabled';
export const WELCOME_BONUS = 'welcome_bonus';
export const GA_CHECK_REQUIRED = 'ga_check_required';
export const PM_COINBASE_ENABLED = 'pm_coinbase_enabled';
export const BLACK_FRIDAY_FEATURE = 'black_friday';
export const STAND_WITH_UKRAINE = 'stand_with_ukraine';
